import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AuthService from '../../../api/services/AuthService';
import { $ } from 'react-jquery-plugin';
import { alertWarningMessage, alertErrorMessage, alertSuccessMessage } from '../../../customComponent/CustomAlertMessage';
import LoaderHelper from '../../../customComponent/Loading/LoaderHelper';
import Swal from 'sweetalert2'

const SIPUserPopup = ({ selectedUser }) => {
    const [recentPlans, setRecentPlans] = useState([]);
    const [selectedPlanIndex, setSelectedPlanIndex] = useState(null);
    const [selectedPaymentInfo, setSelectedPaymentInfo] = useState(null);
    const [rejectionReason, setRejectionReason] = useState('');

    // Payment modal states
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedInstallment, setSelectedInstallment] = useState(null);
    const [availableCurrency, setAvailableCurrency] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState({});
    const [amount, setAmount] = useState("");
    const [txNo, setTxNo] = useState("");
    const [txImage, setTxImage] = useState("");
    const [transactionDate, setTransactionDate] = useState("");

    const [packageList, setPackageList] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [newInstallmentDate, setNewInstallmentDate] = useState("");
    const fetchAllPackageList = async () => {
        try {
            const result = await AuthService.allPackageList();
            if (result.success) {
                setPackageList(result?.data[0] || []);
            }
        } catch {
            alertErrorMessage("Failed to fetch packages");
        }
    };
    useEffect(() => {
        fetchAllPackageList();
    }, []);

    const getPayments = async () => {
        try {
            LoaderHelper.loaderStatus(true);
            const result = await AuthService.getPayments("SIP", selectedUser._id);
            if (result?.success && Array.isArray(result.data)) {
                setRecentPlans(result.data);
            }
        } catch (error) {
            console.error("Error fetching payments:", error);
        } finally {
            LoaderHelper.loaderStatus(false);
        }
    };

    useEffect(() => {
        const fetchPayments = () => {
            if (selectedUser && selectedUser._id) {
                getPayments();
            }
        }

        fetchPayments();

        // Listen for refresh events from EarningSIP component
        const handleRefresh = () => {
            fetchPayments();
        };

        window.addEventListener('refreshRecentPlans', handleRefresh);

        return () => {
            window.removeEventListener('refreshRecentPlans', handleRefresh);
        };
    }, []);

    const showPaymentInfo = (installment) => {
        setSelectedPaymentInfo(installment);
        $("#payment_info_modal").modal('show');
    };

    const showRejectionReason = (reason) => {
        setRejectionReason(reason);
        $("#rejection_reason_modal").modal('show');
    };

    const showPayButton = (installment) => {
        setSelectedInstallment(installment);
        setAmount(installment.installment_amount);
        setTransactionDate(new Date().toISOString().split('T')[0]); // Set current date as default
        setShowPaymentModal(true);
        getDepositActiveCoins();
    };

    const getDepositActiveCoins = async () => {
        try {
            LoaderHelper.loaderStatus(true);
            const result = await AuthService.depositActiveCoinsFiat();
            if (result?.success) {
                setAvailableCurrency(result?.data);
                if (result?.data?.length > 0) {
                    setSelectedCurrency(result?.data[0]);
                }
            }
        } catch (error) {
            console.error("Error fetching deposit coins:", error);
        } finally {
            LoaderHelper.loaderStatus(false);
        }
    };

    const handleSelectDepositCoin = (item) => {
        setSelectedCurrency(item);
    };

    const handleChangeImage = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
            const maxSize = 2 * 1024 * 1024; // 2MB
            if (allowedTypes.includes(file.type) && file.size <= maxSize) {
                setTxImage(file);
                alertSuccessMessage(file?.name);
            } else {
                if (!allowedTypes.includes(file.type)) {
                    alertErrorMessage("Only PNG, JPEG, and JPG file types are allowed.");
                } else {
                    alertErrorMessage("Max image size is 2MB.");
                }
                setTxImage("");
            }
        }
    };

    const handleSubmitPayment = async () => {
        try {
            if (!amount) {
                alertErrorMessage('Please Enter Amount...');
                return;
            }
            if (!transactionDate) {
                alertErrorMessage('Please Select Transaction Date...');
                return;
            }
            if (!txImage) {
                alertErrorMessage('Please Upload Image...');
                return;
            }
            // if (!selectedCurrency) {
            //     alertErrorMessage('Please select valid currency');
            //     return;
            // }
            if (!txNo) {
                alertErrorMessage('Please Enter Transaction Number...');
                return;
            }

            LoaderHelper.loaderStatus(true);
            var formData = new FormData();
            formData.append("amount", amount);
            formData.append("transaction_slip", txImage);
            formData.append("transaction_number", txNo);
            formData.append("transaction_date", transactionDate);
            // formData.append("currency_id", selectedCurrency?._id);
            formData.append("installment_id", selectedInstallment?._id);

            // Replace with actual SIP payment API
            const result = await AuthService.sipInstallmentPayment(formData);
            if (result?.success) {
                alertSuccessMessage("Payment submitted successfully");
                setShowPaymentModal(false);
                setAmount("");
                setTxImage("");
                setTxNo("");
                setTransactionDate("");
                // // Refresh plans
                // window.location.reload();
                await getPayments();
            } else {
                alertErrorMessage(result?.message);
            }
        } catch (error) {
            alertErrorMessage("Payment submission failed");
        } finally {
            LoaderHelper.loaderStatus(false);
        }
    };

    const bankLabels = {
        account_holder_name: "Account Holder Name",
        account_number: "Account Number",
        bank_name: "Bank Name",
        ifsc_code: "IFSC Code",
        swift_code: "SWIFT Code",
        country: "Country",
        aba_routing_number: "ABA Routing Number",
        currency: "Currency",
        iban: "IBAN"
    };

    const handlePlanSelection = (idx) => {
        setSelectedPlanIndex(idx);
        setSelectedPackage(recentPlans[idx].planDetails?.plan_id || null);
        console.log("recentPlans[idx].investmentDate", recentPlans[idx]);
        setNewInstallmentDate(recentPlans[idx].investmentDate ? moment(recentPlans[idx].investmentDate).format('YYYY-MM-DD') : "");

        // Scroll to UPCOMING installment after a short delay to ensure DOM is updated
        setTimeout(() => {
            const upcomingRow = document.querySelector(`tr[data-status="UPCOMING"]`);
            if (upcomingRow) {
                upcomingRow.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        }, 100);
    };

    const handleChangePackage = async (e) => {
        const newPlanId = e.target.value;
        const selectedPackageData = packageList.find(item => item.plan_id === newPlanId);
        
        if (!newPlanId) {
            setSelectedPackage(null);
            return;
        }
        console.log("Changing package to:", newPlanId, selectedPackageData);
        console.log("recentPlans[selectedPlanIndex]", recentPlans[selectedPlanIndex]);

        // Show confirmation popup
        const result = await Swal.fire({
            title: 'Change Package?',
            html: `Are you sure you want to change the package to:<br/><strong>${selectedPackageData?.duration_days} ${selectedPackageData?.duration_days > 1 ? 'Years' : 'Year'} Plan</strong>?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#FFDC88',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Change Package',
            cancelButtonText: 'Cancel',
            background: '#2c2c2c',
            color: '#fff'
        });

        if (result.isConfirmed) {
            try {
                LoaderHelper.loaderStatus(true);
                const currentInvestment = recentPlans[selectedPlanIndex];
                
                // Call API to update package
                const apiResult = await AuthService.sipUpdateInstallments(
                    currentInvestment._id,
                    newPlanId
                );

                if (apiResult?.success) {
                    alertSuccessMessage("Package changed successfully");
                    setSelectedPackage(newPlanId);
                    // Refresh payment data
                    await getPayments();
                } else {
                    alertErrorMessage(apiResult?.message || "Failed to change package");
                    // Reset to previous package
                    setSelectedPackage(currentInvestment.planDetails?.plan_id || null);
                }
            } catch (error) {
                console.error("Error changing package:", error);
                alertErrorMessage("Failed to change package");
                // Reset to previous package
                setSelectedPackage(recentPlans[selectedPlanIndex].planDetails?.plan_id || null);
            } finally {
                LoaderHelper.loaderStatus(false);
            }
        } else {
            // User cancelled, reset to previous package
            setSelectedPackage(recentPlans[selectedPlanIndex].planDetails?.plan_id || null);
        }
    }

    const handleChangeInstallmentDate = async (selectedDate) => {
        if (!selectedDate) {
            return;
        }

        const currentInvestment = recentPlans[selectedPlanIndex];
        const originalDate = currentInvestment?.investmentDate;
        
        // Check if date actually changed
        if (moment(originalDate).format('YYYY-MM-DD') === selectedDate) {
            return;
        }

        // Show confirmation popup
        const result = await Swal.fire({
            title: 'Change Installment Date?',
            html: `Are you sure you want to change the installment date from:<br/><strong>${moment(originalDate).format("DD MMM YYYY")}</strong><br/>to<br/><strong>${moment(selectedDate).format("DD MMM YYYY")}</strong>?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#FFDC88',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Change Date',
            cancelButtonText: 'Cancel',
            background: '#2c2c2c',
            color: '#fff'
        });

        if (result.isConfirmed) {
            try {
                LoaderHelper.loaderStatus(true);
                
                // Call API to update installment date
                const apiResult = await AuthService.sipChangeInstallmentDate(
                    currentInvestment._id,
                    selectedDate
                );

                if (apiResult?.success) {
                    alertSuccessMessage("Installment date changed successfully");
                    // Refresh payment data
                    await getPayments();
                } else {
                    alertErrorMessage(apiResult?.message || "Failed to change installment date");
                    // Reset to original date
                    setNewInstallmentDate(originalDate ? moment(originalDate).format('YYYY-MM-DD') : "");
                }
            } catch (error) {
                console.error("Error changing installment date:", error);
                alertErrorMessage("Failed to change installment date");
                // Reset to original date
                setNewInstallmentDate(originalDate ? moment(originalDate).format('YYYY-MM-DD') : "");
            } finally {
                LoaderHelper.loaderStatus(false);
            }
        } else {
            // User cancelled, reset to original date
            setNewInstallmentDate(originalDate ? moment(originalDate).format('YYYY-MM-DD') : "");
        }
    }

    return (
        <>
            <div className="dashboard_recent_s pt-0 pb-3">
                <div className='d-flex justify-content-between align-items-center'>
                    <h4 className='py-3'><span style={{ color: '#FFDC88' }}>SIP </span>Active Plan Details</h4>
                    {/* <a className="more_btn" href="/user_profile/transaction_history">More &gt;</a> */}
                </div>
                <div className="row py-2" style={{ minHeight: '400px', background: '#232323', borderRadius: '8px' }}>
                    {/* Sidebar */}
                    <div className="col-md-2" style={{ borderRight: '1px solid #333' }}>
                        <ul className="list-group my-2" style={{ background: 'transparent' }}>
                            {recentPlans.map((plan, idx) => (
                                <li
                                    key={plan._id}
                                    className={`list-group-item ${selectedPlanIndex === idx ? 'active' : ''}`}
                                    style={{
                                        borderEndStartRadius: '12px',
                                        borderStartStartRadius: '12px',
                                        cursor: 'pointer',
                                        background: selectedPlanIndex === idx ? '#2c2c2c' : 'transparent',
                                        color: selectedPlanIndex === idx ? '#FFDC88' : '#fff',
                                        border: plan.status === 'INACTIVE' ? '2px solid #dc3545' : 'none',
                                        borderBottom: '1px solid #333',
                                        boxShadow: plan.status === 'INACTIVE' ? '0 0 8px rgba(220, 53, 69, 0.3)' : 'none'
                                    }}
                                    onClick={() => handlePlanSelection(idx)}
                                >
                                    <div>
                                        <span style={{ color: plan.status === 'INACTIVE' ? '#dc3545' : '#FFDC88' }}>
                                            <b>{plan.planDetails?.duration_days} {plan.planDetails?.duration_days == 1 ? 'Year' : 'Years'} Plan</b>
                                        </span>
                                    </div>
                                    <div>
                                        {plan.status === 'INACTIVE' && (
                                            <span style={{
                                                color: '#dc3545',
                                                fontSize: '0.7rem',
                                                fontWeight: 'bold',
                                                marginLeft: '5px'
                                            }}>
                                                (UNDER PROCESS)
                                            </span>
                                        )}
                                    </div>
                                    <div><span style={{ color: '#fff', fontSize: '0.8rem' }} >₹{plan.amount}/Monthly</span></div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* Details Panel */}
                    <div className="col-md-10" style={{ background: '#232323', color: '#fff' }}>
                        {selectedPlanIndex !== null && recentPlans[selectedPlanIndex] ? (
                            <div className="py-2" style={{
                                background: '#232323',
                                borderRadius: '12px',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
                            }}>
                                {/* Plan Details in 5 columns */}
                                <div className="row pt-2 mb-2">
                                    <div className="col-md-2 text-center">
                                        <div className="mb-2">
                                            <span style={{ color: '#aaa', fontSize: '0.8rem', display: 'block' }}>Investment ID</span>
                                            <span style={{ color: '#FFDC88', fontWeight: 600, fontSize: '0.9rem' }}>
                                                {recentPlans[selectedPlanIndex].investmentId}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-2 text-center">
                                        <div className="mb-2">
                                            <span style={{ color: '#aaa', fontSize: '0.8rem', display: 'block' }}>Amount</span>
                                            <span style={{ color: '#FFDC88', fontWeight: 600, fontSize: '0.9rem' }}>
                                                ₹{recentPlans[selectedPlanIndex].amount}/Monthly
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-2 text-center">
                                        <div className="mb-2">
                                            <span style={{ color: '#aaa', fontSize: '0.8rem', display: 'block' }}>Duration</span>
                                            <span style={{ color: '#FFDC88', fontWeight: 600, fontSize: '0.9rem' }}>
                                                {recentPlans[selectedPlanIndex].planDetails?.duration_days || recentPlans[selectedPlanIndex].duration_days} {((recentPlans[selectedPlanIndex].planDetails?.duration_days || recentPlans[selectedPlanIndex].duration_days) > 1 ? 'Years' : 'Year')}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-2 text-center">
                                        <div className="mb-2">
                                            <span style={{ color: '#aaa', fontSize: '0.8rem', display: 'block' }}>Yearly ROI</span>
                                            <span style={{ color: '#FFDC88', fontWeight: 600, fontSize: '0.9rem' }}>
                                                {recentPlans[selectedPlanIndex].planDetails?.return_percentage_yearly || recentPlans[selectedPlanIndex].return_percentage_yearly}%
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-2 text-center">
                                        <div className="mb-2">
                                            <span style={{ color: '#aaa', fontSize: '0.8rem', display: 'block' }}>Plan Status</span>
                                            <span style={{
                                                color: recentPlans[selectedPlanIndex].status === 'ACTIVE' ? '#4caf50' :
                                                    recentPlans[selectedPlanIndex].status === 'INACTIVE' ? '#dc3545' : '#ffc107',
                                                fontWeight: 600,
                                                fontSize: '0.9rem'
                                            }}>
                                                {recentPlans[selectedPlanIndex].status}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Next Installment Details */}
                                <div className="table-responsive" style={{
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    border: '1px solid #444',
                                    borderRadius: '8px'
                                }} id="installment-table-container">
                                    <table className="table table-bordered table-sm p-0 mt-0" style={{ background: '#232323', color: '#fff', borderRadius: '8px', fontSize: '0.9rem', marginBottom: 0 }}>
                                        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                            <tr style={{ background: '#2c2c2c', color: '#FFDC88', textAlign: 'center' }}>
                                                <th style={{ padding: '10px 8px', fontSize: '0.85rem' }}>Installment #</th>
                                                <th style={{ padding: '10px 8px', fontSize: '0.85rem' }}>Schedule Date</th>
                                                <th style={{ padding: '10px 8px', fontSize: '0.85rem' }}>Amount</th>
                                                <th style={{ padding: '10px 8px', fontSize: '0.85rem' }}>Payment Status</th>
                                                <th style={{ padding: '10px 8px', fontSize: '0.85rem' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {recentPlans[selectedPlanIndex].installmentSchedules?.map((inst, i) => {
                                                return (
                                                    <tr
                                                        key={inst._id}
                                                        data-status={inst.displayStatus}
                                                        style={inst?.overdueDays ? { border: '2px solid #ff4444', background: '#3d2525' } : { background: '#232323' }}
                                                    >
                                                        <td style={{ color: '#FFDC88', textAlign: 'center', fontWeight: 600, padding: '8px', fontSize: '0.85rem' }}>
                                                            {inst.installment_number}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '8px', fontSize: '0.85rem' }}>
                                                            {moment(inst.installment_date).format("YYYY-MM-DD")}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '8px', fontSize: '0.85rem' }}>
                                                            ₹{inst.installment_amount}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '8px', fontSize: '0.85rem' }}>
                                                            <div>
                                                                <span style={{
                                                                    color: inst.displayStatus === 'COMPLETED' || inst.displayStatus === 'PAID' ? '#4caf50' :
                                                                        inst.displayStatus === 'UPCOMING' ? '#ffc107' :
                                                                            inst.displayStatus === 'FUTURE' ? '#17a2b8' :
                                                                                inst.displayStatus === 'PAYMENT FAILED' ? '#dc3545' : '#ff9800',
                                                                    fontWeight: 600
                                                                }}>
                                                                    {inst.displayStatus}
                                                                </span>
                                                                {inst.displayStatus === 'PAYMENT FAILED' && inst.rejected_reason && (
                                                                    <div style={{ marginTop: '4px' }}>
                                                                        <small
                                                                            style={{ textDecoration: 'underline', cursor: 'pointer', fontSize: '0.7rem' }}
                                                                            onClick={() => showRejectionReason(inst.rejected_reason)}
                                                                        >
                                                                            View Reason
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '8px' }}>
                                                            {inst.displayStatus === 'PAID' || inst.displayStatus === 'COMPLETED' ? (
                                                                <div
                                                                    style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        gap: '5px',
                                                                        color: '#FFDC88',
                                                                        padding: '6px 12px',
                                                                        borderRadius: '20px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '0.75rem',
                                                                        fontWeight: '600',
                                                                        textDecoration: 'none',
                                                                        transition: 'all 0.3s ease',
                                                                        border: '1px solid #FFDC88',
                                                                        background: 'transparent',
                                                                    }}
                                                                    onClick={() => showPaymentInfo(inst)}
                                                                >
                                                                    <i className="ri-information-line" style={{ fontSize: '0.8rem' }}></i>
                                                                    Payment Info
                                                                </div>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-warning btn-sm"
                                                                    style={{
                                                                        color: '#232323',
                                                                        background: inst.displayStatus === "UPCOMING" || inst.displayStatus === "OVERDUE" || inst?.displayStatus == "PAYMENT FAILED" ? '#FFDC88' : '#666',
                                                                        border: 'none',
                                                                        borderRadius: '6px',
                                                                        fontWeight: 600,
                                                                        fontSize: '0.75rem',
                                                                        padding: '4px 12px'
                                                                    }}
                                                                    // disabled={!(inst.displayStatus === "UPCOMING" || inst.displayStatus === "PAYMENT FAILED")}
                                                                    onClick={() => showPayButton(inst)}
                                                                >
                                                                    Pay Now
                                                                </button>
                                                            )}
                                                            {inst?.overdueDays != null && inst.displayStatus != "UNDER PROCESS" && (
                                                                <div className='mt-2' style={{ color: '#ff4444', fontWeight: 'bold', fontSize: '0.7rem', marginTop: '2px' }}>
                                                                    Overdue by {inst?.overdueDays} days
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <div className="form-group d-flex flex-row align-items-center gap-2">
                                                <label style={{ whiteSpace: 'nowrap' }}>Package</label>
                                                <select disabled={packageList?.length === 0} className="form-select form-control shadow-soft-inner" onChange={(e) => {
                                                    handleChangePackage(e);
                                                }} value={selectedPackage || ''}>
                                                    <option value="" style={{ color: 'gray' }}>Select Package </option>
                                                    {packageList?.filter((item) => item.type === 'SIP')?.map((item) => {
                                                        let duration = item?.type == "FIP" ? (item?.duration_days / 365) : item?.duration_days;
                                                        return (
                                                            <option key={item.plan_id} style={{ color: 'gray' }} value={item.plan_id}>{`${item?.type} ${item?.type == "SIP" ? "" : `|| Amount: ${item?.min_amount} - ${item?.max_amount} ${item?.currency}`} || Duration : ${duration} ${duration > 1 ? "Years" : "Year"}`}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group d-flex flex-row align-items-center gap-2">
                                                <label style={{ whiteSpace: 'nowrap' }}>Installment Date</label>
                                                <DatePicker
                                                    selected={newInstallmentDate ? new Date(newInstallmentDate) : null}
                                                    onChange={(date) => {
                                                        if (date) {
                                                            const formattedDate = moment(date).format('YYYY-MM-DD');
                                                            setNewInstallmentDate(formattedDate);
                                                            handleChangeInstallmentDate(formattedDate);
                                                        }
                                                    }}
                                                    dateFormat="dd MMM yyyy"
                                                    className="form-control"
                                                    placeholderText="Select date"
                                                    customInput={
                                                        <input
                                                            style={{
                                                                background: '#1a1a1a',
                                                                border: '1px solid #444',
                                                                color: '#fff',
                                                                cursor: 'pointer',
                                                                width: '100%',
                                                                padding: '8px 12px',
                                                                borderRadius: '4px'
                                                            }}
                                                        />
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div style={{ color: '#FFDC88', textAlign: 'center', padding: '2rem' }}>
                                <div className="no_data_outer">
                                    <div className="no_data_vector">
                                        <img src="/images/Group 1171275449 (1).svg" alt="no-data" />
                                    </div>
                                    <p>Please select a plan to view installment details</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Payment Info Modal */}
            <div className="modal fade" id="payment_info_modal" tabIndex="-1" aria-labelledby="paymentInfoModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ background: '#2c2c2c', color: '#fff' }}>
                        <div className="modal-header" style={{ borderBottom: '1px solid #444' }}>
                            <h5 className="modal-title" style={{ color: '#FFDC88' }}>Payment Information</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ padding: '25px' }}>
                            {selectedPaymentInfo && (
                                <div>
                                    {/* Payment Information Grid */}
                                    <div className="row g-1 mb-1">
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Installment #</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>{selectedPaymentInfo.installment_number}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Amount</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>₹{selectedPaymentInfo.installment_amount}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Installment Date</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    {selectedPaymentInfo.installment_date ? moment(selectedPaymentInfo.installment_date).format("DD MMM YYYY") : 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Payment Date</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    {selectedPaymentInfo.transaction_date ? moment(selectedPaymentInfo.transaction_date).format("DD MMM YYYY") : 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-1 mb-1">
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Transaction Number</strong>
                                                <span style={{ fontSize: '0.9rem', fontWeight: '600', wordBreak: 'break-all' }}>
                                                    {selectedPaymentInfo.transaction_number || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Status</strong>
                                                <span style={{
                                                    color: selectedPaymentInfo.transaction_status === 'SUCCESS' ? '#4caf50' :
                                                        selectedPaymentInfo.transaction_status === 'PENDING' ? '#ffc107' : '#dc3545',
                                                    fontSize: '1rem',
                                                    fontWeight: '600'
                                                }}>
                                                    {selectedPaymentInfo.transaction_status || selectedPaymentInfo.displayStatus}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Paid/Remaining Installments</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    {recentPlans[selectedPlanIndex]?.installmentSchedules?.filter(inst =>
                                                        inst.displayStatus === 'PAID' || inst.displayStatus === 'COMPLETED'
                                                    ).length || 0}/{recentPlans[selectedPlanIndex]?.installmentSchedules?.filter(inst =>
                                                        inst.displayStatus !== 'PAID' && inst.displayStatus !== 'COMPLETED'
                                                    ).length || 0}
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="row g-1 mb-1">
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Total Installments</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    {recentPlans[selectedPlanIndex]?.installmentSchedules?.length || 0}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Plan Duration</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    {recentPlans[selectedPlanIndex]?.planDetails?.duration_days || recentPlans[selectedPlanIndex]?.duration_days}
                                                    {((recentPlans[selectedPlanIndex]?.planDetails?.duration_days || recentPlans[selectedPlanIndex]?.duration_days) > 1 ? ' Years' : ' Year')}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Monthly Amount</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    ₹{recentPlans[selectedPlanIndex]?.amount}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-6">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Yearly ROI</strong>
                                                <span style={{ fontSize: '1rem', fontWeight: '600' }}>
                                                    {recentPlans[selectedPlanIndex]?.planDetails?.return_percentage_yearly || recentPlans[selectedPlanIndex]?.return_percentage_yearly}%
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-1">
                                        <div className="col-md-6 col-12">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Investment ID</strong>
                                                <span style={{ fontSize: '0.9rem', fontWeight: '600', wordBreak: 'break-all' }}>
                                                    {recentPlans[selectedPlanIndex]?.investmentId}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', textAlign: 'center', border: '1px solid #444' }}>
                                                <strong style={{ color: '#FFDC88', fontSize: '0.8rem', display: 'block', marginBottom: '5px' }}>Remarks</strong>
                                                <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>
                                                    {selectedPaymentInfo.transaction_remarks || 'No remarks'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Rejection Reason Modal */}
            <div className="modal fade" id="rejection_reason_modal" tabIndex="-1" aria-labelledby="rejectionReasonModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content" style={{ background: '#2c2c2c', color: '#fff', border: '1px solid #dc3545' }}>
                        <div className="modal-header" style={{ borderBottom: '1px solid #444', background: '#dc3545' }}>
                            <h5 className="modal-title" style={{ color: '#fff' }}>
                                <i className="ri-error-warning-line me-2"></i>Payment Rejected
                            </h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ padding: '20px' }}>
                            <div style={{ textAlign: 'center' }}>
                                <i className="ri-close-circle-line" style={{ fontSize: '4rem', color: '#dc3545', marginBottom: '20px' }}></i>
                                <h6 style={{ color: '#FFDC88', marginBottom: '15px' }}>Rejection Reason:</h6>
                                <p style={{
                                    fontSize: '1rem',
                                    color: '#fff',
                                    lineHeight: '1.6',
                                    background: '#1a1a1a',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    border: '1px solid #444'
                                }}>
                                    {rejectionReason || 'No reason provided'}
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ borderTop: '1px solid #444', justifyContent: 'center' }}>
                            <button
                                type="button"
                                className="btn btn-outline-light"
                                data-bs-dismiss="modal"
                                style={{ borderColor: '#dc3545', color: '#dc3545' }}
                            >
                                <i className="ri-close-line me-1"></i>Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Payment Modal */}
            {showPaymentModal && (
                <div className="modal fade show" style={{
                    display: 'block',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    zIndex: 9999999,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }} tabIndex="-1">
                    <div
                        className="modal-dialog modal-dialog-centered"
                        style={{
                            maxWidth: '95vw',
                            width: '60%',
                            maxHeight: '95vh',
                            margin: '2.5vh auto',
                            padding: '0 10px'
                        }}
                    >
                        <div className="modal-content" style={{
                            background: '#2c2c2c',
                            color: '#fff',
                            border: '1px solid #444',
                            maxHeight: '95vh',
                            overflow: 'hidden',
                            borderRadius: '8px',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div className="modal-header" style={{
                                borderBottom: '1px solid #444',
                                padding: '25px 20px',
                                flexShrink: 0
                            }}>
                                <h5 className="modal-title" style={{
                                    color: '#FFDC88',
                                    fontSize: '1rem',
                                    margin: 0
                                }}>
                                    Pay Installment #{selectedInstallment?.installment_number}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => setShowPaymentModal(false)}
                                    style={{ fontSize: '0.8rem' }}
                                ></button>
                            </div>

                            <div className="modal-body" style={{
                                padding: '20px 15px',
                                overflowY: 'auto',
                                flex: 1
                            }}>
                                <div className="row g-3">
                                    {/* Account Details - Full width on mobile and tablets */}
                                    {/* <div className="col-12 col-xl-6 mb-3">
                                        <h6 style={{
                                            color: '#FFDC88',
                                            marginBottom: '15px',
                                            fontSize: '1rem',
                                            fontWeight: '600'
                                        }}>
                                            Bank Account Details
                                        </h6>
                                        <div style={{
                                            background: '#1a1a1a',
                                            padding: '15px',
                                            borderRadius: '8px',
                                            border: '1px solid #444',
                                            
                                            overflowY: 'auto'
                                        }}>
                                            {Object.entries(selectedCurrency?.bank_details || {})
                                                .filter(([key]) => bankLabels[key])
                                                .map(([key, value], idx) => (
                                                    <div key={idx} className="mb-2 pb-2" style={{ borderBottom: '1px solid #333' }}>
                                                        <div className="d-flex flex-column flex-sm-row justify-content-between">
                                                            <strong style={{
                                                                color: '#FFDC88',
                                                                fontSize: '0.85rem',
                                                                marginBottom: '2px'
                                                            }}>
                                                                {bankLabels[key]}:
                                                            </strong>
                                                            <span style={{
                                                                fontSize: '0.85rem',
                                                                wordBreak: 'break-all',
                                                                lineHeight: '1.4',
                                                                textAlign: 'left'
                                                            }}>
                                                                {value || "-"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div> */}

                                    {/* Payment Form - Full width on mobile and tablets */}
                                    <div className="col-12 col-xl-12">


                                        <div className="mb-3">
                                            <label style={{
                                                color: '#FFDC88',
                                                marginBottom: '8px',
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                display: 'block'
                                            }}>
                                                Amount to Pay
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Amount"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                style={{
                                                    background: '#1a1a1a',
                                                    border: '1px solid #444',
                                                    color: '#fff',
                                                    padding: '10px 12px',
                                                    fontSize: '0.9rem',
                                                    borderRadius: '6px',
                                                    width: '100%'
                                                }}
                                                readOnly
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label style={{
                                                color: '#FFDC88',
                                                marginBottom: '8px',
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                display: 'block'
                                            }}>
                                                Transaction Date
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={transactionDate}
                                                onChange={(e) => setTransactionDate(e.target.value)}
                                                style={{
                                                    background: '#1a1a1a',
                                                    border: '1px solid #444',
                                                    color: '#fff',
                                                    padding: '10px 12px',
                                                    fontSize: '0.9rem',
                                                    borderRadius: '6px',
                                                    width: '100%'
                                                }}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label style={{
                                                color: '#FFDC88',
                                                marginBottom: '8px',
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                display: 'block'
                                            }}>
                                                Transaction Number
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Transaction Number"
                                                value={txNo}
                                                onChange={(e) => setTxNo(e.target.value)}
                                                style={{
                                                    background: '#1a1a1a',
                                                    border: '1px solid #444',
                                                    color: '#fff',
                                                    padding: '10px 12px',
                                                    fontSize: '0.9rem',
                                                    borderRadius: '6px',
                                                    width: '100%'
                                                }}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label style={{
                                                color: '#FFDC88',
                                                marginBottom: '8px',
                                                fontSize: '0.9rem',
                                                fontWeight: '500',
                                                display: 'block'
                                            }}>
                                                Upload Payment Screenshot
                                            </label>
                                            <div className="upload-area" style={{
                                                border: '2px dashed #666',
                                                borderRadius: '8px',
                                                padding: '15px 10px',
                                                textAlign: 'center',
                                                minHeight: '80px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>
                                                <input
                                                    name="file"
                                                    className="inputfile"
                                                    type="file"
                                                    onChange={handleChangeImage}
                                                    style={{ display: 'none' }}
                                                    id="payment-file-upload"
                                                />
                                                <label htmlFor="payment-file-upload" style={{
                                                    cursor: 'pointer',
                                                    color: '#fff',
                                                    margin: 0,
                                                    textAlign: 'center',
                                                    width: '100%'
                                                }}>
                                                    {txImage === "" ? (
                                                        <>
                                                            <i className="ri-upload-cloud-line" style={{
                                                                fontSize: '1.8rem',
                                                                color: '#FFDC88',
                                                                display: 'block',
                                                                marginBottom: '6px'
                                                            }}></i>
                                                            <div style={{
                                                                fontSize: '0.85rem',
                                                                marginBottom: '3px',
                                                                fontWeight: '500'
                                                            }}>
                                                                Choose a File
                                                            </div>
                                                            <small style={{
                                                                fontSize: '0.75rem',
                                                                color: '#aaa',
                                                                lineHeight: '1.3'
                                                            }}>
                                                                Tap to select file
                                                            </small>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="ri-check-double-fill text-success" style={{
                                                                fontSize: '1.8rem',
                                                                display: 'block',
                                                                marginBottom: '6px'
                                                            }}></i>
                                                            <div style={{
                                                                fontSize: '0.85rem',
                                                                marginBottom: '3px',
                                                                fontWeight: '500'
                                                            }}>
                                                                File Uploaded
                                                            </div>
                                                            <small style={{
                                                                fontSize: '0.75rem',
                                                                color: '#aaa',
                                                                wordBreak: 'break-all',
                                                                lineHeight: '1.3'
                                                            }}>
                                                                {txImage?.name}
                                                            </small>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer" style={{
                                borderTop: '1px solid #444',
                                padding: '15px 20px',
                                flexShrink: 0
                            }}>
                                <div className="d-flex flex-column justify-content-center flex-sm-row gap-2 w-100">
                                    <button
                                        type="button"
                                        className="btn btn-secondary "
                                        onClick={() => setShowPaymentModal(false)}
                                        style={{
                                            padding: '10px 15px',
                                            fontSize: '0.9rem',
                                            order: '2'
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-warning"
                                        disabled={!amount || !txImage || !txNo || !transactionDate}
                                        onClick={handleSubmitPayment}
                                        style={{
                                            background: '#FFDC88',
                                            color: '#232323',
                                            border: 'none',
                                            padding: '10px 15px',
                                            fontSize: '0.9rem',
                                            fontWeight: '600',
                                            order: '1'
                                        }}
                                    >
                                        Submit Payment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SIPUserPopup;